import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../styles/CTASection.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

export default function CTASection() {
  return (
    <section className="section cta-section">
      <div className="container">
        <motion.div className="cta__content" {...fadeUp(0)}>
          <h2 className="cta__title">Let's Build the Future Together</h2>
          <p className="cta__subtitle">
            Whether you're launching a new digital product, modernizing legacy systems, or exploring AI transformation, Kodefactor can help accelerate your journey.
          </p>

          <div className="cta__buttons">
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              <Link to="/contact" className="cta__btn cta__btn--primary">
                <span>Schedule a Consultation</span>
                <ArrowRight size={18} />
              </Link>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
              <Link to="/contact" className="cta__btn cta__btn--secondary">
                <span>Contact Us</span>
                <ArrowRight size={18} />
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
